import { render, staticRenderFns } from "./b-ticket.vue?vue&type=template&id=f0fa33b4&scoped=true"
import script from "./b-ticket.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket.vue?vue&type=style&index=0&id=f0fa33b4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fa33b4",
  null
  
)

export default component.exports